import { useEffect, useRef } from 'react';
import videojs from 'video.js';
import { Props } from './MediaPlayer.model';

export const useMediaPlayer = ({ onReady, url, type }: Props) => {
	const videoRef = useRef<any>(null);
	const playerRef = useRef<any>(null);

	const isAudio = () => type === 'Audio';

	useEffect(() => {
		if (!playerRef.current) {
			const videoElement = videoRef.current;
			if (!videoElement) return;

			const player = (playerRef.current = videojs(
				videoElement,
				{
					autoplay: true,
					controls: true,
					fluid: true,
					inactivityTimeout: isAudio() ? 0 : 200,
					preload: 'metadata',
					responsive: true,
					sources: [
						{ src: url, type: 'video/mp4' },
						{ src: url, type: 'video/mov' },
						{ src: url, type: 'video/webm' },
						{ src: url, type: 'video/mkv' },
						{ src: url, type: 'video/3gp' },
						{ src: url, type: 'audio/mp3' },
						{ src: url, type: 'audio/aac' },
						{ src: url, type: 'audio/wav' },
						{ src: url, type: 'audio/flac' },
						{ src: url, type: 'audio/ogg' },
						{ src: url, type: 'audio/wma' },
						{ src: url, type: 'audio/aiff' },
					],
				},
				() => {
					onReady && onReady(player);
				}
			));
		}
	}, []);

	useEffect(() => {
		return () => {
			if (playerRef.current) {
				playerRef.current.dispose();
				playerRef.current = null;
			}
		};
	}, []);
	return {
		isAudio,
		state: {
			videoRef,
		},
	};
};
